import React from "react";
import { Text } from "@pancakeswap-libs/uikit";
import useI18n from "hooks/useI18n";
import CardValue from "./CardValue";

const CakeHarvestBalance = ({ earningsSum }) => {
  const TranslateString = useI18n();

  if (!localStorage.getItem("account")) {
    return (
      <Text color="textDisabled" style={{ marginBottom: "10px" }}>
        {TranslateString(298, "Locked")}
      </Text>
    );
  }

  return <CardValue value={earningsSum} />;
};

export default CakeHarvestBalance;
